import {
  IBasicOptionSummary,
  IBenefitSummary,
  IPlanBenefitSummaryList,
  IPlanOptionsSummary,
  IPlanSummary,
  ISpecifiedItemOptionSummary,
} from '@nibtravel/shared/util/models';

export type SpecifiedItemFn = (
  planId: number
) => ISpecifiedItemOptionSummary | undefined;

export type BasicOptionFn = (
  planId: number | undefined
) => IBasicOptionSummary[] | undefined;

export type PlanSummaryMap = Record<number, IPlanSummary>;
export type PlanBenefitSummaryListMap = Record<number, IPlanBenefitSummaryList>;

export interface IPlanState {
  planSummaries: PlanSummaryMap;
  planBenefitsSummaryLists: PlanBenefitSummaryListMap;
  planBenefitsSummary: IBenefitSummary[];
  planOptionsSummary: Record<number, IPlanOptionsSummary>;
  apiPlanOptions: Record<number, IPlanOptionsSummary>; // Adding this as need to manipulate values for cancellation, so keeping the reference of the orignal data coming from the API
  implicitCancellationValue?: number | undefined;
}

export const defaultPlanState: IPlanState = {
  planSummaries: {},
  planBenefitsSummaryLists: {},
  planBenefitsSummary: [],
  planOptionsSummary: {},
  apiPlanOptions: {},
};
